// extracted by mini-css-extract-plugin
module.exports = {"container":"failureDirectory_container__1Yy8h","wrap":"failureDirectory_wrap__1weLn","table":"failureDirectory_table__SMrRz"};